import { faMoon } from "@fortawesome/duotone-regular-svg-icons/faMoon";
import { faSun } from "@fortawesome/duotone-regular-svg-icons/faSun";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Center,
  MantineColorScheme,
  SegmentedControl,
  useMantineColorScheme,
  useMantineTheme,
} from "@mantine/core";

interface ThemeSwitchProps {
  style?: React.CSSProperties;
}

const ThemeSwitch = ({ style }: ThemeSwitchProps) => {
  const theme = useMantineTheme();
  const { setColorScheme, colorScheme } = useMantineColorScheme();

  return (
    <SegmentedControl
      data={[
        {
          label: (
            <Center style={{ gap: 10 }}>
              <FontAwesomeIcon
                icon={faSun}
                color={theme.colors.yellow[4]}
                size="1x"
              />
              Light
            </Center>
          ),
          value: "light",
        },
        { label: "Auto", value: "auto" },
        {
          label: (
            <Center style={{ gap: 10 }}>
              <FontAwesomeIcon
                icon={faMoon}
                color={theme.colors.blue[6]}
                size="1x"
              />
              Dark
            </Center>
          ),
          value: "dark",
        },
      ]}
      value={colorScheme}
      onChange={(value) => setColorScheme(value as MantineColorScheme)}
      style={style}
    />
  );
};

export default ThemeSwitch;
